import { Component, AfterViewInit, inject } from '@angular/core';
import Swiper from "swiper";
import { EffectFade, Navigation, Pagination, Autoplay } from "swiper/modules";
import { NgClass, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { RedirectionService } from '../../services/redirection.service';
@Component({
    selector: 'app-carousel-banner',
    imports: [NgClass, NgOptimizedImage, RouterModule, SafeHtmlPipe],
    templateUrl: './carousel-banner.component.html',
    styleUrl: './carousel-banner.component.scss'
})
export class CarouselBannerComponent implements AfterViewInit {
    assetsCDNUrl = environment.assetsCDNUrl;
    _redirection = inject(RedirectionService);
    private slider!: Swiper;
    ngAfterViewInit() {
        if (typeof window != "undefined") {
            setTimeout(() => {
                this.loadSlider();
            }, 500);
        }
    }

    // Load Slider
    loadSlider() {
        this.slider = new Swiper("#page-slider", {
            modules: [Navigation, Pagination, EffectFade, Autoplay],
            loop: false,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 1000,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                clickable: true,
                el: '.swiper-pagination-mb',
            },
        });
    }

    bannerContent: any = [

        {
            "image_url": "/assets/images/banners/banner-1.png",
            "image_mob_url": "/assets/images/banners/banner-mobile-1.png",
            "title": "Wealth, <u>Your Way</u>",
            "subtitle": "<p>We grow your wealth with trust and personalized solutions.</p>",
            "btn_text": "Let's Talk",
            "alt_text": "banner Image 4",
            "class_name": ''
        },
        {
            "image_url": "/assets/images/banners/banner-2.png",
            "image_mob_url": "/assets/images/banners/banner-mobile-2.png",
            "title": "Wealth, <u>Your Way</u>",
            "subtitle": "<p>We grow your wealth with trust and personalized solutions.</p>",
            "btn_text": "Let's Talk",
            "alt_text": "banner Image 3",
            "class_name": ''
        },


        {
            "image_url": "/assets/images/banners/banner-3.png",
            "image_mob_url": "/assets/images/banners/banner-mobile-3.png",
            "title": "Wealth, <u>Your Way</u>",
            "subtitle": "<p>We grow your wealth with trust and personalized solutions.</p>",
            "btn_text": "Let's Talk",
            "alt_text": "banner Image 1",
            "class_name": ''
        },
        {
            "image_url": "/assets/images/banners/banner-4.png",
            "image_mob_url": "/assets/images/banners/banner-mobile-4.png",
            "title": "Wealth, <u>Your Way</u>",
            "subtitle": "<p>We grow your wealth with trust and personalized solutions.</p>",
            "btn_text": "Let's Talk",
            "alt_text": "banner Image 1",
            "class_name": ''
        }


    ];

    handler_redirect(selectedTab: number) {
        this._redirection.solution.set(selectedTab);
        setTimeout(() => {
            this._redirection.handler_scroll('js-scrollContent');
        }, 500);
    }
}
